import React, { useEffect, useState } from "react";
import logo2 from "../assets/images/logo2.png"
import { HiMenuAlt3 } from "react-icons/hi"
import { RxCross1 } from "react-icons/rx"

const Navbar = () => {
  const [sticky, setSticky] = useState(false);
  const [open, setOpen] = useState(false);
  const menuLinks = [
    { name: "HOME", link: "#home" },
    { name: "ABOUT", link: "#about" },
    { name: "SKILLS", link: "#skills" },
    { name: "PROJECTS", link: "#projects" },
    { name: "CONTACT", link: "#contact" },
  ];
  useEffect(() => {
    window.addEventListener("scroll", () => {
      const nav = document.querySelector("nav");
      window.scrollY > 0 ? setSticky(true) : setSticky(false);
    });
  }, []);


  return (
    <nav
      className={`fixed w-full left-0 top-0 z-[999] backdrop-blur ${
        sticky ? "bg-white/60  text-gray-900" : "text-white"
      }`}
    >
      <div className="flex items-center justify-between">
        <div className="mx-7">
          <a  rel="noopener noreferrer" href="#home"><img src={logo2} className="w-1/5"  alt="nameLogo" /></a>
         
        </div>
        <div
          className={`  ${
            sticky ? "md:bg-white/0 bg-white" : "bg-white"
          } text-gray-900 md:block hidden px-7 py-2 font-medium  rounded-bl-full`}
        >
          <ul className="flex items-center gap-1 py-2 text-lg">
            {menuLinks?.map((menu, i) => (
              <li key={i}>
                <a rel="noopener noreferrer" className="px-6 hover:text-gray-600" href={menu?.link}>{menu?.name}</a>
              </li>
            ))}
          </ul>
        </div>
        {/*hover: opacity-100 blur-none */}
        {/*hover: opacity-20 blur-[2px] */}
        <div
          onClick={() => setOpen(!open)}
          className={`z-[999]  ${
            open ? "text-gray-900" : "text-gray-100"
          } text-3xl md:hidden m-5`}
        >
         {!open? <HiMenuAlt3 name="menu"  />:<RxCross1 />} 
        </div>
        <div
          className={`md:hidden text-gray-900 absolute w-2/3 h-screen
      px-7 py-2 font-medium bg-white top-0 duration-300 ${
        open ? "right-0" : "right-[-100%]"
      }`}
        >
      
          <ul className="flex flex-col justify-center h-full gap-10 py-2 text-lg">
            {menuLinks?.map((menu, i) => (
              <li
                onClick={() => setOpen(false)}
                key={i}
              >
                <a rel="noopener noreferrer" href={menu?.link}>{menu?.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
